/**
 * Variant Gallery Switcher
 * Troca todas as fotos da galeria ao mudar de variante
 * usando /products/handle.js da API nativa do Shopify
 */
(function () {
  let productData = null;

  // Pré-carrega os dados do produto
  function loadProductData() {
    const match = window.location.pathname.match(/\/products\/([^/?]+)/);
    if (!match) return;
    fetch('/products/' + match[1] + '.js')
      .then(r => r.json())
      .then(data => { productData = data; })
      .catch(e => console.error('variant-gallery-switcher:', e));
  }

  // Escuta mudanças de variante
  function init() {
    loadProductData();

    document.addEventListener('change', function (e) {
      const input = e.target.closest('input[data-variant-id]');
      if (!input || !productData) return;

      const variantId = parseInt(input.dataset.variantId);
      if (!variantId) return;

      const variant = productData.variants.find(v => v.id === variantId);
      if (!variant || !variant.featured_image) return;

      // Pega o filename base da featured_image (ex: "3032403000X")
      const featuredSrc = variant.featured_image.src;
      const filename = featuredSrc.split('/').pop().split('?')[0]; // 3032403000X.1.webp
      const prefix = filename.replace(/\.\d+\.webp$/, '').replace(/\.\d+\.jpg$/, '').replace(/\.\d+\.png$/, '');
      // prefix = "3032403000X"

      // Filtra todas as imagens do produto com esse prefixo
      const variantImages = productData.images
        .filter(img => {
          const imgFile = img.split('/').pop().split('?')[0];
          return imgFile.startsWith(prefix + '.');
        })
        .sort();

      if (variantImages.length === 0) {
        // fallback: usa só a featured_image
        variantImages.push(featuredSrc);
      }

      updateGallery(variantImages);
    });
  }

  function updateGallery(imageSrcs) {
    const gallery = document.querySelector('media-gallery');
    if (!gallery) return;

    // Pega todos os slides do slideshow
    const slides = gallery.querySelectorAll('.product-media-container--image');

    slides.forEach((slide, i) => {
      const src = imageSrcs[i];
      if (!src) {
        // Esconde slides extras que não têm imagem nessa variante
        slide.style.display = 'none';
        return;
      }
      slide.style.display = '';

      const baseSrc = src.split('?')[0];
      const img = slide.querySelector('img');
      if (!img) return;

      const widths = [180, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 1944, 2048, 3840];
      img.src = baseSrc + '?width=1080';
      img.srcset = widths.map(w => `${baseSrc}?width=${w} ${w}w`).join(', ');
    });

    // Atualiza também os thumbnails
    const thumbnails = gallery.querySelectorAll('.slideshow-controls__thumbnail img, .dialog-thumbnails-list__thumbnail img');
    thumbnails.forEach((img, i) => {
      const src = imageSrcs[i];
      if (!src) return;
      const baseSrc = src.split('?')[0];
      img.src = baseSrc + '?width=240';
      img.srcset = baseSrc + '?width=240 240w, ' + baseSrc + '?width=480 480w';
    });

    // Volta pro primeiro slide
    const slideshow = gallery.slideshow;
    if (slideshow && typeof slideshow.select === 'function') {
      slideshow.select(0, undefined, { animate: false });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();